import axios from "axios";
import { SignupAuthModel } from "../../datamodels/auth/signupAuthModel";

export async function authorizeSignUpApiCall(passedToken: String) {
  const response = await axios.post<SignupAuthModel>(
    `/user/Auth/signup/check`,
    {
      token: passedToken,
      deviceInfo: {
        notificationId: "test",
        appVersion: "1.9.2.1",
        appOS: "iOS",
      },
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
